<template>
  <div>
    <el-menu class="navbar" mode="horizontal">
      <hamburger
        class="hamburger-container"
        :toggleClick="toggleSideBar"
        :isActive="sidebar.opened"
      ></hamburger>
      <breadcrumb></breadcrumb>
      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <span style="margin-right: 24px; font-size: 18px; line-height: 50px;">{{
            info.name
          }}</span>
          <img class="user-avatar" :src="avatar || img" />
          <i class="el-icon-caret-bottom"></i>
        </div>
        <el-dropdown-menu class="user-dropdown" slot="dropdown">
          <!-- <el-dropdown-item @click="openSet"> 基本设置 </el-dropdown-item>
          <el-dropdown-item @click="openpsw"> 安全设置 </el-dropdown-item> -->
          <el-dropdown-item>
            <span @click="openSet" style="display: block">基本设置</span>
          </el-dropdown-item>
          <el-dropdown-item divided>
            <span @click="openpsw" style="display: block">安全设置</span>
          </el-dropdown-item>
          <el-dropdown-item style="display: block">
            <span @click="logout" style="display: block">退出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </el-menu>
    <el-dialog title="基础设置" :visible.sync="dialogVisible" width="40%">
      <el-form :model="admin" ref="adminForm" label-width="150px" size="small">
        <el-form-item label="登录帐号：">
          <el-input
            v-model="info.account"
            disabled="true"
            style="width: 250px"
          ></el-input>
        </el-form-item>
        <el-form-item label="用户名称：">
          <el-input v-model="info.name" style="width: 250px"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="handleDialogConfirm()" size="small"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog title="安全设置" :visible.sync="pswdialogVisible" width="40%">
      <el-form
        :model="pwd"
        :rules="rules"
        ref="pswForm"
        label-width="150px"
        size="small"
        show-message="true"
      >
        <el-form-item label="旧的登录密码：">
          <el-input
            type="password"
            v-model="pwd.oldPwd"
            style="width: 250px"
          ></el-input>
        </el-form-item>
        <el-form-item label="新的登录密码：">
          <el-input
            v-model="pwd.pwd1"
            style="width: 250px"
            placeholder="密码必须包含大小写、字母、数字任意二者组合"
          ></el-input>
        </el-form-item>
        <el-form-item label="新的重复密码：">
          <el-input
            v-model="pwd.pwd2"
            style="width: 250px"
            placeholder="密码必须包含大小写、字母、数字任意二者组合"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="pswdialogVisible = false" size="small"
          >取 消</el-button
        >
        <el-button type="primary" @click="handlePwdConfirm()" size="small"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";
import userImg from "@/assets/images/user.jpg";
import { updateUser, setPassword } from "@/api/common";
const defaultPassword = {
  oldPwd: "",
  pwd1: "",
  pwd2: "",
};

export default {
  components: {
    Breadcrumb,
    Hamburger,
  },
  computed: {
    ...mapGetters(["sidebar", "avatar", "info"]),
  },
  data() {
    return {
      img: userImg,
      dialogVisible: false,
      pswdialogVisible: false,
      admin: this.$store.state.user.info,
      pwd: Object.assign({}, defaultPassword),
      rules: {
        oldPwd: [
          { required: true, message: "请输入旧密码", trigger: "change" },
        ],
        pwd1: [{ required: true, message: "请输入密码", trigger: "change" }],
        pwd2: [{ required: true, message: "请输入密码", trigger: "change" }],
      },
    };
  },
  created() {},
  methods: {
    handlePwdConfirm() {
      this.$confirm(`确定修改密码`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            ...this.pwd,
            userId: this.info.id,
          };
          console.log(params);
          setPassword(params).then((response) => {
            this.$message({
              type: "success",
              message: "成功!",
            });
            this.pswdialogVisible = false;
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消",
          });
        });
    },
    handleDialogConfirm() {
      this.$confirm(`确定提交`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          updateUser(this.admin).then((response) => {
            this.$message({
              type: "success",
              message: "成功!",
            });
            store.dispatch('GetInfo')
            this.dialogVisible = false;

          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消",
          });
        });
    },
    openSet() {
      this.dialogVisible = true;
    },
    openpsw() {
      this.pswdialogVisible = true;
    },
    toggleSideBar() {
      this.$store.dispatch("ToggleSideBar");
    },
    logout() {
      this.$store.dispatch("LogOut").then(() => {
        location.reload(); // 为了重新实例化vue-router对象 避免bug
        this.$router.push("/login");
      });
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }
  .avatar-container {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 35px;
    .avatar-wrapper {
      display: flex;
      justify-items: center;
      cursor: pointer;
      margin-top: 5px;
      position: relative;
      .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }
      .el-icon-caret-bottom {
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue